namespace $.$$ {

	export class $shm_ba_mention_stats_task_list_head extends $.$shm_ba_mention_stats_task_list_head {

		controls() {
			return this.search_showed() ? [ this.Filter() ] : []
		}

	}

}
